export enum GlobalHiltiStoresRoutes {
  BASE = 'stores',
  DIRECTORY = 'directory'
}
